const cartRight = document.querySelector('[js-cart-right-box]');
const header = document.querySelector('.header-wrapper');
const eyebrow = document.querySelector('.eyebrow');
const orderForm = document.querySelector('.order-form');

if (cartRight) {
    const orderFormStyles = window.getComputedStyle(orderForm);
    const orderFormTopMargin = parseFloat(orderFormStyles.marginTop);
    const headerHeight = header.clientHeight;
    const eyebrowHeight = eyebrow.clientHeight;

    const topPosition = headerHeight + eyebrowHeight + orderFormTopMargin;

    cartRight.style.top = `${topPosition}px`;
}